import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import Spinner from '@components/spinner/Spinner';
import backgroundImage from '@assets/images/auth/auth_background_new.png';
import Logo from '@assets/images/logo.svg';
import blueUnderline from '@assets/images/auth/auth_blue_underline.svg';

const AuthLayout = () => (
  <main className="relative h-dvh w-full overflow-hidden">
    {/* Background */}
    <img
      src={backgroundImage}
      alt=""
      aria-hidden="true"
      className="absolute inset-0 size-full object-cover"
    />

    <div className="relative z-10 flex size-full">
      {/* Left branding */}
      {/* Left branding */}
      <section className="hidden flex-1 items-start lg:flex">
        <div
          className="
      ml-[clamp(3rem,8vw,8rem)]
      mt-[clamp(4rem,20vh,10rem)]
      w-full
      max-w-[390px]
    "
        >
          {/* TARA Logo */}
          <img
            src={Logo}
            alt="TARA"
            className="
        w-[clamp(90px,8vw,145px)]
        object-contain
      "
          />

          {/* Heading */}
          <h1
            className="
        mt-[clamp(0.5rem,1.2vh,1rem)]
        text-[clamp(20px,2vw,30px)]
        font-bold
        leading-[1.2]
      "
          >
            <span className="text-primary5">Empowering Educators.</span>
            <br />
            <span className="text-primaryDark">Inspiring Futures.</span>
          </h1>

          {/* Description */}
          <p
            className="
        mt-[clamp(0.5rem,1.5vh,1rem)]
        max-w-[300px]
        text-[clamp(11px,1vw,15px)]
        leading-[1.4]
        text-grey
      "
          >
            Create engaging homeworks,
            <br />
            track student progress and
            <br />
            help every learner move forward.
          </p>

          {/* Blue underline */}
          <img
            src={blueUnderline}
            alt=""
            aria-hidden="true"
            className="
        mt-[clamp(0.5rem,1.2vh,0.75rem)]
        w-[clamp(60px,6vw,95px)]
      "
          />
        </div>
      </section>

      {/* Right authentication */}
      <section
        className="
          flex
          size-full
          items-center
          justify-center
          p-4
          lg:w-[55%]
          lg:px-8
          lg:py-5
        "
      >
        <div
          className="
            w-full
            max-w-[574px]
            rounded-48
            bg-[#FAF9FF]

            p-8
            sm:px-12

            sm:py-9
            md:px-16

            md:py-10
            lg:px-[84px]

            lg:py-10
            [@media(max-height:600px)]:rounded-[36px]

            [@media(max-height:600px)]:px-8
            [@media(max-height:600px)]:py-4

            [@media(max-height:700px)]:px-10
            [@media(max-height:700px)]:py-5

            [@media(max-height:800px)]:px-12
            [@media(max-height:800px)]:py-7
          "
        >
          <Suspense
            fallback={
              <div className="flex min-h-[300px] items-center justify-center">
                <Spinner />
              </div>
            }
          >
            <Outlet />
          </Suspense>
        </div>
      </section>
    </div>
  </main>
);

export default AuthLayout;
